import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";
import {ManualPayment} from "../../../model/manual-payment.interface";
import {BmDebtCollectionService} from "../../../service/bm-debt-collection.service";

@Component({
    selector: 'bm-manual-payment-dialog',
    templateUrl: './manual-payment-dialog.component.html',
    standalone: false
})
export class BmManualPaymentDialogComponent implements OnChanges {

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    @Input() defaultName = 'Manual Payment';

    @Output() closed = new EventEmitter<void>();

    form: ManualPayment = {
        name: '',
        plannedDate: new Date(),
        amount: 0,
        currency: 'EUR'
    };

    constructor(protected debtCollectionService: BmDebtCollectionService) {
    }

    ngOnChanges(): void {
        if (this.visible) {
            this.form = {
                name: this.defaultName,
                plannedDate: new Date(),
                amount: 0,
                currency: 'EUR'
            };
        }
    }

    /* ---------- VALIDATION GETTERS ---------- */

    get isNameInvalid(): boolean {
        return !this.form.name || !this.form.name.trim();
    }

    get isAmountInvalid(): boolean {
        return !this.form.amount || this.form.amount <= 0;
    }

    get isFormValid(): boolean {
        return !this.isNameInvalid && !this.isAmountInvalid;
    }

    /* ---------- ACTIONS ---------- */

    async submit(): Promise<void> {
        if (!this.isFormValid) {
            return;
        }

        await this.debtCollectionService.addManualPayment({...this.form});
        this.visibleChange.emit(false)
        this.closed.emit();
    }

    cancel(): void {
        this.visibleChange.emit(false)
        this.closed.emit();
    }
}
